
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Check } from "lucide-react";

interface StepCardProps {
  title: string;
  children: React.ReactNode;
  onNext?: () => void;
  onPrevious?: () => void;
  nextButtonText?: string;
  showPrevious?: boolean;
  isLastStep?: boolean;
  nextDisabled?: boolean;
  nextButtonClassName?: string;
  showNext?: boolean;
  onCheckAll?: () => void;
  showCheckAll?: boolean;
  customRightButton?: React.ReactNode;
}

const StepCard = ({ 
  title, 
  children, 
  onNext, 
  onPrevious, 
  nextButtonText = "Next", 
  showPrevious = false,
  isLastStep = false,
  nextDisabled = false,
  nextButtonClassName = "",
  showNext = true,
  onCheckAll,
  showCheckAll = false,
  customRightButton
}: StepCardProps) => {
  return (
    <div className="space-y-6">
      {title && (
        <div className="text-center">
          <h2 className="text-xl font-semibold text-foreground">{title}</h2>
        </div>
      )}
      
      <div className="space-y-6">
        {children}
      </div>
      
      {(showPrevious || showNext || showCheckAll || customRightButton) && (
        <div className="flex justify-between items-center gap-3 pt-4 border-t border-border/30">
          <div className="flex gap-3">
            {showPrevious && (
              <Button 
                variant="outline" 
                onClick={onPrevious}
                className="flex items-center gap-2 px-4 py-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Back
              </Button>
            )}
          </div>
          
          <div className="flex gap-3">
            {showCheckAll && onCheckAll && (
              <Button 
                onClick={onCheckAll}
                variant="outline"
                className="flex items-center gap-2 px-4 py-2"
              >
                <Check className="h-4 w-4" />
                Check All
              </Button>
            )}
            
            {customRightButton && customRightButton}
            
            {!isLastStep && onNext && showNext && !customRightButton && (
              <Button 
                onClick={onNext}
                className={`px-6 py-2 ${nextButtonClassName}`}
                disabled={nextDisabled}
              >
                {nextButtonText}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StepCard;
